import { render, staticRenderFns } from "./NavigationDrawerLeftDesktop.vue?vue&type=template&id=a9b6f4e0&scoped=true"
import script from "./NavigationDrawerLeftDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerLeftDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerLeftDesktop.vue?vue&type=style&index=0&id=a9b6f4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b6f4e0",
  null
  
)

export default component.exports